export const CONTACT_EMAIL = "emily@bobosdonuts.com";

export const PRIVACY_POLICY = {
  id: "privacy",
  title: "Privacy Policy",
  updated: "Last updated in June 2026",
  sections: [
    {
      heading: "Who we are",
      body: [
        "Bobo's Donuts™ is a family-run donut truck based in Mattawan, Michigan. This Privacy Policy explains how we collect, use, and protect the information you share with us when you visit our website or reach out to book the truck.",
      ],
    },
    {
      heading: "Information we collect",
      body: [
        "When you fill out one of our forms — booking the truck, requesting a catering quote, or asking about franchising — we collect the details you choose to provide. That can include your name, email address, phone number, event date, guest count, and any message you send our way.",
        "We do not ask for payment card numbers or sensitive personal data through this website.",
      ],
    },
    {
      heading: "How we use your information",
      body: [
        "We use your information to respond to your request, plan your event, send you a quote, and keep in touch about your booking. We may also use it to improve our service and to let you know about Bobo's news if you have asked us to.",
      ],
    },
    {
      heading: "Cookies and similar technologies",
      body: [
        "Our website uses cookies to remember your preferences and to understand how visitors use the site. You can manage your choices at any time through the cookie banner. For full details, please read our separate Cookie Policy.",
      ],
    },
    {
      heading: "How we share information",
      body: [
        "We never sell your personal information. We only share it with trusted service providers who help us run the business — such as email and hosting partners — and only as needed to serve you. We may also disclose information when the law requires it.",
      ],
    },
    {
      heading: "How long we keep it",
      body: [
        "We keep your information only as long as we need it to serve your request and meet our legal and bookkeeping obligations, and then we securely remove it.",
      ],
    },
    {
      heading: "Your choices and rights",
      body: [
        "You can ask us to access, correct, or delete the personal information we hold about you at any time. To make a request, simply email us using the address below and we will be glad to help.",
      ],
    },
    {
      heading: "Children's privacy",
      body: [
        "Our website is intended for a general audience and is not directed at young children. We do not knowingly collect personal information from children under thirteen years of age.",
      ],
    },
    {
      heading: "Contact us about privacy",
      body: [
        `If you have any questions about this Privacy Policy or your information, please email us at ${CONTACT_EMAIL} and our team will respond as soon as we can.`,
      ],
    },
  ],
};

export const COOKIE_POLICY = {
  id: "cookie",
  title: "Cookie Policy",
  updated: "Last updated in June 2026",
  sections: [
    {
      heading: "What cookies actually are",
      body: [
        "Cookies are small text files that a website stores on your device. They help the site remember your choices, keep things working smoothly, and let us understand how visitors use our pages.",
      ],
    },
    {
      heading: "The cookies we use",
      body: [
        "Essential cookies keep the website running and remember your cookie preferences. These are always on because the site needs them to work.",
        "Preference cookies remember small choices you make so your next visit feels familiar and friendly.",
        "Analytics cookies help us count visits and see which pages people love most, so we can keep making the site better.",
      ],
    },
    {
      heading: "Your cookie choices explained",
      body: [
        "When you first arrive, our cookie banner lets you choose what you are comfortable with. \"Allow cookies\" turns everything on. \"Some cookies\" keeps the essentials plus your preferences, but skips analytics. \"No cookies, just donuts\" keeps only the essential cookies the site truly needs.",
        "You can change your mind at any time by clearing this site's data in your browser, which brings the banner back.",
      ],
    },
    {
      heading: "Managing cookies in your browser",
      body: [
        "Every major browser lets you view, block, and delete cookies through its settings menu. Please remember that blocking some cookies may change how parts of the website behave.",
      ],
    },
    {
      heading: "Changes to this policy",
      body: [
        "We may update this Cookie Policy from time to time as our website grows. When we do, we will revise the date shown at the top of this notice.",
      ],
    },
    {
      heading: "Contact us about cookies",
      body: [
        `If you have any questions about how we use cookies, please reach out to us at ${CONTACT_EMAIL} and we will be happy to help.`,
      ],
    },
  ],
};
